import { NgModule } from "@angular/core";

import { ShineAnimationComponent } from "./shine-animation.component";

// prettier-ignore
@NgModule({
  declarations: [ShineAnimationComponent],
  imports: [],
  providers: [],
  exports: [ShineAnimationComponent],
})
export class ShineAnimationModule {}
